<template>
  <v-row
    class="mb-1"
    dense
  >
    <v-col class="px-3">
      <v-list class="py-0">
        <v-list-item
          v-if="provider.quality_rating_score > 0"
          class="pa-0"
          style="min-height: 0px"
        >
          <template #prepend>
            <img
              v-if="store.state.site['Custom Ratings']?.length > 0"
              :alt="$bct('Custom Quality Rating Score')"
              :src="store.state.site['Custom Ratings'][0].pass"
              height="24"
            />
            <v-icon
              v-else
              alt=""
              color="#FFD200"
              icon="star"
              role="presentation"
              size="24"
            />
          </template>
          <v-list-item-title
            class="fs-16 fw-400"
            data-testid="quality-score-summary"
          >
            <span>
              {{ $bct(provider.quality_rating_name) }}: {{ provider.quality_rating_score }}
              {{ $bct('out of') }} {{ provider.quality_rating_max }}
            </span>
          </v-list-item-title>
        </v-list-item>
        <template v-if="openingsEnabled">
          <v-list-item
            v-for="(spot, index) in provider.vacancy_descriptions"
            v-show="spot.vacant != null"
            :key="index"
            class="pa-0"
            style="min-height: 0px"
          >
            <template #prepend>
              <v-icon
                v-if="spot.vacant"
                class="c-green"
                data-testid="vacancy-icon"
                icon="check_circle"
                size="24"
              />

              <v-icon
                v-if="spot.vacant == false"
                class="c-red"
                data-testid="vacancy-icon"
                icon="cancel"
                size="24"
              />
            </template>
            <v-list-item-title class="fs-16 fw-400">
              <span v-if="spot.vacant == false">
                {{ $bct('Openings not available for') }}
              </span>
              <span v-if="spot.vacant == true">
                {{ $bct('Openings available for') }}
              </span>
              <span class="ms-1">
                {{ monthsToAgeString(spot.min) }} - {{ monthsToAgeString(spot.max) }}
              </span>
            </v-list-item-title>
          </v-list-item>
        </template>
        <v-list-item
          class="pa-0"
          style="min-height: 0px"
        >
          <template #prepend>
            <v-icon
              class="c-black"
              icon="query_builder"
              size="24"
            />
          </template>
          <v-list-item-title
            v-if="provider.hours_description"
            class="c-black fs-16 fw-400"
          >
            {{ $bct(provider.hours_description) }}
          </v-list-item-title>
          <v-list-item-title
            v-else
            class="fs-16 fw-400"
          >
            {{ $bct('Hours not available') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="provider.payment_subsidies_accepted.length > 0"
          class="pa-0"
          style="min-height: 0px"
        >
          <template #prepend>
            <v-icon
              color="#578052"
              icon="attach_money"
              size="24"
            />
          </template>
          <v-list-item-title class="c-black fs-16 fw-400">
            {{ $bct('Financial assistance options available') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>

<script setup>
import { useStore } from 'vuex';

import useAgeCalculations from '@/shared/composables/useAgeCalculations';

const { monthsToAgeString } = useAgeCalculations();
const store = useStore();
const $bct = inject('translator');

const props = defineProps({
  provider: {
    type: Object,
    default: null,
  },
});

const openingsEnabled = computed(() => {
  return (
    store.state.schemas[props.provider.schema_id].meta.openings.enabled &&
    store.state.schemas[props.provider.schema_id].meta.openings.public
  );
});
</script>
